// ResultComponent.jsx

import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";

const ResultComponent = ({ data = [], onClick = () => {} }) => {
  return (
    <Grid
      container
      spacing={1}
      className="easy-putaway-container mt-1 text-center"
    >
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={12}
          md={7}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
          sx={{
            margin: "0 auto",
            // height: "80vh",
            // alignItems: "center",
            // display: "flex",
          }}
        >
          <div className="easy-putaway-card ">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
              <Grid item xs={12} md={12}>
                <Typography
                  variant="subtitle1"
                  className="   text-center"
                  sx={{
                    color: item?.Status == "FAILED" ?"red":" green",
                    fontWeight: " bold",
                    border: item?.Status == "FAILED" ?"1px solid red!important":" 1px solid green!important",
                    background: item?.Status == "FAILED" ?"#ff000040":" #0080002b",
                  }}
                >
                  {item?.Status == "FAILED" ? "FAILED" : "SUCCESS"}
                </Typography>
              </Grid>

            {  item?.Status == "FAILED" &&
              <Grid item xs={12} md={12}>
                <Typography variant="body1" className="value"> 
                { item.Message}
                </Typography>
              </Grid>}
              {item?.vocTypName &&
              <Grid item xs={12} md={12}>
                <Typography variant="body1" className="value"> 
                { item.vocTypName}
                </Typography>
              </Grid>}
             { item?.vocNo &&
              <Grid item xs={12} md={12}>
                <Typography variant="body1" className="value">
                  {item?.vocNo}
                </Typography>
              </Grid>}
             { item?.partyName &&
              <Grid item xs={12} md={12}>
                <Typography variant="body1" className="value">
                  {item?.partyName}
                </Typography>
              </Grid>}
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default ResultComponent;
